<div class="chat-bot-container">
    <!-- <app-poi-sidebar></app-poi-sidebar> -->
    <chat-view></chat-view>
</div>